export const teamTypes = {
    FETCH_TEAM_MEMBERS_REQUEST: "FETCH_TEAM_MEMBERS_REQUEST",
    FETCH_TEAM_MEMBERS_SUCCESS: "FETCH_TEAM_MEMBERS_SUCCESS",
    FETCH_TEAM_MEMBERS_FAILURE: "FETCH_TEAM_MEMBERS_FAILURE",
};
